// Global
export const SET_SIDENAV_ACTIVE = 'global/SET_SIDENAV_ACTIVE';
export const SET_FOOTER = 'global/SET_FOOTER';
export const RECEIVED_GAMETYPES = 'global/RECEIVED_GAMETYPES';

// Drawer
export const SET_DRAWER = 'global/SET_DRAWER';
export const SET_DRAWER_ACTIVE = 'global/SET_DRAWER_ACTIVE';

// Feed
export const RECEIVED_FEED = 'feed/RECEIVED_FEED';
export const APPEND_FEED = 'feed/APPEND_FEED';
export const RECEIVED_FEED_GAMETYPES = 'feed/RECEIVED_FEED_GAMETYPES';
export const UPDATE_FEED_GAMETYPE = 'feed/UPDATE_FEED_GAMETYPE';
export const DISABLE_ALL_FEED_GAMETYPES = 'feed/DISABLE_ALL_FEED_GAMETYPES';
export const PREPEND_FEED_ITEM = 'feed/PREPEND_FEED_ITEM';
export const QUEUE_FEED_ITEM = 'feed/QUEUE_FEED_ITEM';
export const PREPEND_QUEUE = 'feed/PREPEND_QUEUE';

// News
export const RECEIVED_NEWS = 'news/RECEIVED_NEWS';
export const RECEIVED_MOST_POPULAR_NEWS = 'news/RECEIVED_MOST_POPULAR_NEWS';
export const RECEIVED_NEWS_ARTICLE = 'news/RECEIVED_NEWS_ARTICLE';
export const RECEIVED_RELATED_NEWS = 'news/RECEIVED_RELATED_NEWS';
export const APPEND_NEWS = 'news/APPEND_NEWS';

// INSIGHTS
export const RECEIVED_INSIGHTS = 'insights/RECEIVED_INSIGHTS';
export const RESET_INSIGHTS = 'insights/RESET_INSIGHTS';

// Offers
export const RECEIVED_OFFERS = 'offers/RECEIVED_OFFERS';
export const RECEIVED_OFFER = 'offers/RECEIVED_OFFER';
export const RESET_OFFER = 'offers/RESET_OFFER';
export const RECEIVED_SUGGESTED_OFFERS = 'offers/RECEIVED_SUGGESTED_OFFERS';
export const RECEIVED_EXPIRING_OFFERS = 'offers/RECEIVED_EXPIRING_OFFERS';
export const RECEIVED_TRENDING_OFFER = 'offers/RECEIVED_TRENDING_OFFER';
export const APPEND_OFFERS = 'offers/APPEND_OFFERS';

// Casinos
export const RECEIVED_CASINOS = 'casinos/RECEIVED_CASINOS';
export const RECEIVED_POPULAR_CASINOS = 'casinos/RECEIVED_POPULAR_CASINOS';
export const RECEIVED_CASINOS_TOTAL_VIEWS = 'casinos/RECEIVED_CASINOS_TOTAL_VIEWS';
export const APPEND_CASINOS = 'casinos/APPEND_CASINOS';

// Casino
export const RECEIVED_CASINO = 'casino/RECEIVED_CASINO';
export const RECEIVED_CASINO_FEED = 'casino/RECEIVED_CASINO_FEED';
export const RECEIVED_CASINO_GAMETYPES = 'casino/RECEIVED_CASINO_GAMETYPES';
export const RECEIVED_CASINO_FEED_SEARCH = 'casino/RECEIVED_CASINO_FEED_SEARCH';
export const APPEND_CASINO_FEED = 'casino/APPEND_CASINO_FEED';
export const APPEND_CASINO_FEED_SEARCH = 'casino/APPEND_CASINO_FEED_SEARCH';
export const UPDATE_CASINO_CATEGORIES = 'casino/UPDATE_CASINO_CATEGORIES';
export const UPDATE_CASINO_GAMETYPES = 'casino/UPDATE_CASINO_GAMETYPES';
export const SET_CASINO_VIEW = 'casino/SET_CASINO_VIEW';
export const SET_LOADING_FEED = 'casino/SET_LOADING_FEED';
export const SET_LOADING_FEED_SEARCH = 'casino/SET_LOADING_FEED_SEARCH';
export const RESET_CASINO_GAMETYPE_FILTERS = 'casino/RESET_CASINO_GAMETYPE_FILTERS';
export const RESET_CASINO = 'casino/RESET_CASINO';
export const RECEIVED_CASINO_TYPES = 'casino/RECEIVED_CASINO_TYPES';

// Map
export const SET_DIALOG_ACTIVE = 'map/SET_DIALOG_ACTIVE';
export const SET_DIALOG_PEAK = 'map/SET_DIALOG_PEAK';
export const SET_DIALOG_OVERLAY = 'map/SET_DIALOG_OVERLAY';
export const SET_LOADING = 'map/SET_LOADING';
export const RECEIVED_DIALOG_CASINO = 'map/RECEIVED_DIALOG_CASINO';
export const RECEIVED_DIALOG_CASINO_OFFERS = 'map/RECEIVED_DIALOG_CASINO_OFFERS';
export const RECEIVED_DIALOG_CASINO_STATUS = 'map/RECEIVED_DIALOG_CASINO_STATUS';

// Games
export const RECEIVED_LATEST_GAMES = 'games/RECEIVED_LATEST_GAMES';
export const RECEIVED_MOST_POPULAR_GAMES = 'games/RECEIVED_MOST_POPULAR_GAMES';
export const RECEIVED_PREFILTERED_GAMES = 'games/RECEIVED_PREFILTERED_GAMES';
export const RECEIVED_GAMES = 'games/RECEIVED_GAMES';
export const RECEIVED_GOTW = 'games/RECEIVED_GOTW';
export const APPEND_GAMES = 'games/APPEND_GAMES';
export const RECEIVED_GAMES_GAMETYPES = 'games/RECEIVED_GAMES_GAMETYPES';
export const UPDATE_GAMES_GAMETYPES = 'games/UPDATE_GAMES_GAMETYPES';
export const UPDATE_GAMES_ORDER = 'games/UPDATE_GAMES_ORDER';
export const DISABLE_ALL_GAMES_FILTERS = 'games/DISABLE_ALL_GAMES_FILTERS';
export const RECEIVED_GAME_THEMES = 'games/RECEIVED_GAME_THEMES';
export const UPDATE_GAME_THEMES = 'games/UPDATE_GAME_THEMES';
export const RECEIVED_GAME_CATEGORIES = 'games/RECEIVED_GAME_CATEGORIES';
export const UPDATE_GAME_CATEGORIES = 'games/UPDATE_GAME_CATEGORIES';
export const RECEIVED_SEARCH_GAMES = 'games/RECEIVED_SEARCH_GAMES';
export const APPEND_SEARCH_GAMES = 'games/APPEND_SEARCH_GAMES';
export const SET_GAMES_SEARCH_TERM = 'games/SET_GAMES_SEARCH_TERM';
export const CLEAR_SEARCH_GAMES = 'games/CLEAR_SEARCH_GAMES';
export const SET_GAMES_VIEW = 'games/SET_GAMES_VIEW';

// Game
export const RECEIVED_GAME = 'game/RECEIVED_GAME';
export const RESET_GAME = 'game/RESET_GAME';

// Suppliers
export const RECEIVED_SUPPLIERS = 'suppliers/RECEIVED_SUPPLIERS';
export const APPEND_SUPPLIERS = 'suppliers/APPEND_SUPPLIERS';
export const RECEIVED_SUPPLIERS_SUMMARY = 'suppliers/RECEIVED_SUPPLIERS_SUMMARY';

// Supplier
export const RECEIVED_SUPPLIER = 'supplier/RECEIVED_SUPPLIER';
export const RESET_SUPPLIER = 'supplier/RESET_SUPPLIER';
export const RECEIVED_SUPPLIER_GAMES = 'supplier/RECEIVED_SUPPLIER_GAMES';
export const APPEND_SUPPLIER_GAMES = 'supplier/APPEND_SUPPLIER_GAMES';

export const RECEIVED_SUPPLIER_GAMES_GAMETYPES = 'supplier/RECEIVED_SUPPLIER_GAMES_GAMETYPES';
export const UPDATE_SUPPLIER_GAMES_GAMETYPES = 'supplier/UPDATE_SUPPLIER_GAMES_GAMETYPES';
export const UPDATE_SUPPLIER_GAMES_ORDER = 'supplier/UPDATE_SUPPLIER_GAMES_ORDER';
export const DISABLE_SUPPLIER_GAMES_FILTERS = 'supplier/DISABLE_SUPPLIER_GAMES_FILTERS';
export const RECEIVED_SUPPLIER_GAME_THEMES = 'supplier/RECEIVED_SUPPLIER_GAME_THEMES';
export const UPDATE_SUPPLIER_GAME_THEMES = 'supplier/UPDATE_SUPPLIER_GAME_THEMES';
export const RECEIVED_SUPPLIER_GAME_CATEGORIES = 'supplier/RECEIVED_SUPPLIER_GAME_CATEGORIES';
export const UPDATE_SUPPLIER_GAME_CATEGORIES = 'supplier/UPDATE_SUPPLIER_GAME_CATEGORIES';

export const RECEIVED_SUPPLIER_SEARCH_GAMES = 'supplier/RECEIVED_SUPPLIER_SEARCH_GAMES';
export const APPEND_SUPPLIER_SEARCH_GAMES = 'supplier/APPEND_SUPPLIER_SEARCH_GAMES';
export const CLEAR_SUPPLIER_SEARCH_GAMES = 'supplier/CLEAR_SUPPLIER_SEARCH_GAMES';

export const SET_SUPPLIER_GAMES_VIEW = 'supplier/SET_SUPPLIER_GAMES_VIEW';

// User
export const RECEIVED_USER = 'user/RECEIVED_USER';
export const SET_USER_INITIALISED = 'user/SET_USER_INITIALISED';

export const RECEIVED_FAVOURITE_CASINOS_SUMMARY = 'user/RECEIVED_FAVOURITE_CASINOS_SUMMARY';
export const RECEIVED_FAVOURITE_CASINOS = 'user/RECEIVED_FAVOURITE_CASINOS';
export const APPEND_FAVOURITE_CASINOS = 'user/APPEND_FAVOURITE_CASINOS';
export const ADD_FAVOURITE_CASINO = 'user/ADD_FAVOURITE_CASINO';
export const REMOVE_FAVOURITE_CASINO = 'user/REMOVE_FAVOURITE_CASINO';

export const RECEIVED_RECENTLY_PLAYED_GAMES = 'user/RECEIVED_RECENTLY_PLAYED_GAMES';
export const ADD_RECENTLY_PLAYED_GAME = 'user/ADD_RECENTLY_PLAYED_GAME';
export const RECEIVED_FAVOURITE_GAMES_SUMMARY = 'user/RECEIVED_FAVOURITE_GAMES_SUMMARY';
export const RECEIVED_FAVOURITE_GAMES = 'user/RECEIVED_FAVOURITE_GAMES';
export const APPEND_FAVOURITE_GAMES = 'user/APPEND_FAVOURITE_GAMES';
export const ADD_FAVOURITE_GAME = 'user/ADD_FAVOURITE_GAME';
export const REMOVE_FAVOURITE_GAME = 'user/REMOVE_FAVOURITE_GAME';

export const RECEIVED_FAVOURITE_OFFERS_SUMMARY = 'user/RECEIVED_FAVOURITE_OFFERS_SUMMARY';
export const RECEIVED_FAVOURITE_OFFERS = 'user/RECEIVED_FAVOURITE_OFFERS';
export const APPEND_FAVOURITE_OFFERS = 'user/APPEND_FAVOURITE_OFFERS';
export const ADD_FAVOURITE_OFFER = 'user/ADD_FAVOURITE_OFFER';
export const REMOVE_FAVOURITE_OFFER = 'user/REMOVE_FAVOURITE_OFFER';

export const RECEIVED_FAVOURITE_SUPPLIERS_SUMMARY = 'user/RECEIVED_FAVOURITE_SUPPLIERS_SUMMARY';
export const RECEIVED_FAVOURITE_SUPPLIERS = 'user/RECEIVED_FAVOURITE_SUPPLIERS';
export const APPEND_FAVOURITE_SUPPLIERS = 'user/APPEND_FAVOURITE_SUPPLIERS';
export const ADD_FAVOURITE_SUPPLIER = 'user/ADD_FAVOURITE_SUPPLIER';
export const REMOVE_FAVOURITE_SUPPLIER = 'user/REMOVE_FAVOURITE_SUPPLIER';

export const RECEIVED_CITIES = 'city/RECEIVED_CITIES';
export const UPDATE_CITIES_ENABLED = 'city/UPDATE_CITIES_ENABLED';
export const RECEIVED_COUNTRIES = 'country/RECEIVED_COUNTRIES';
export const UPDATE_COUNTRIES_ENABLED = 'country/UPDATE_COUNTRIES_ENABLED';



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/mutation-types.js